import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "./authContextValue";

/**
 * Consumer hook for the auth context.
 *
 * Throws when used outside of ``<AuthProvider>`` — guards against
 * silent stale renders. Call sites that need a non-throwing variant
 * (e.g. the public auth pages) should branch on ``status`` instead.
 */
export function useAuthContext(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error("useAuthContext must be used inside <AuthProvider>");
  }
  return ctx;
}
